import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableFooter,
  TableRow,
} from "@mui/material";

import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type DashBoardTable = {
  topHeader: string[];
  data: any;
  total?: number;
  onEdit?: (row: any) => void;
  onDelete?: (row: any) => void;
  status?: string;
};

export function CostEstimateSummary({
  data,
  topHeader,
  onEdit,
  onDelete,
  status,
}: DashBoardTable) {
  const styles = getStyles(defaultStyles);
  const yearArray = [
    "1st Year",
    "2nd Year",
    "3rd Year",
    "4th Year",
    "5th Year",
    "6th Year",
    "7th Year",
    "8th Year",
    "9th Year",
    "10th Year",
    "Other Necessary Provisions",
    "Total Cost Required",
  ];

  const formatCurrency = (val: any) => {
    if (val === null || val === undefined || val === "") return "-";
    const num = Number(val);
    if (Number.isNaN(num)) return String(val);
    return `₹${new Intl.NumberFormat("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num)}`;
  };

  const safeData = Array.isArray(data) ? data : [];

  const totalCostRequired = safeData.reduce(
    (acc: number, d: any) =>
      acc + Number(typeof d === "object" ? d.costRequired || 0 : d || 0),
    0
  );

  const totalCostProgress = safeData.reduce(
    (acc: number, d: any) =>
      acc + Number(typeof d === "object" ? d.costProgress || 0 : 0),
    0
  );

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {topHeader.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((yeardata: any, index: number) => {
            if (!yeardata) return null;
            return (
              <TableRow key={index}>
                {topHeader.map((headerItem, hIdx) => {
                  let content: any = null;
                  if (hIdx === 0) {
                    content = yearArray[index];
                  } else if (
                    headerItem.toLowerCase().includes("cost required") ||
                    (headerItem.toLowerCase().includes("cost") &&
                      !headerItem.toLowerCase().includes("progress") &&
                      hIdx === 1)
                  ) {
                    content = formatCurrency(
                      typeof yeardata === "object"
                        ? yeardata.costRequired
                        : yeardata
                    );
                  } else if (
                    headerItem.toLowerCase().includes("cost progress") ||
                    headerItem.toLowerCase().includes("progress")
                  ) {
                    content = formatCurrency(
                      typeof yeardata === "object"
                        ? yeardata.costProgress
                        : null
                    );
                  } else {
                    content =
                      typeof yeardata === "object"
                        ? yeardata[headerItem] ?? "-"
                        : yeardata;
                  }

                  return (
                    <TableCell
                      align="center"
                      {...styles("cell")}
                      key={`${index}-${hIdx}`}
                    >
                      {content}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            {topHeader.map((headerItem, hIdx) => {
              let content: any = null;
              if (hIdx === 0) {
                content = "Total";
              } else if (
                headerItem.toLowerCase().includes("cost required") ||
                (headerItem.toLowerCase().includes("cost") &&
                  !headerItem.toLowerCase().includes("progress") &&
                  hIdx === 1)
              ) {
                content = `${formatCurrency(totalCostRequired)}`;
              } else if (
                headerItem.toLowerCase().includes("cost progress") ||
                headerItem.toLowerCase().includes("progress")
              ) {
                content = `${formatCurrency(totalCostProgress)}`;
              } else {
                content = "-";
              }

              return (
                <TableCell
                  align="center"
                  {...styles("cell")}
                  key={`total-${hIdx}`}
                >
                  <strong>{content}</strong>
                </TableCell>
              );
            })}
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
